import { Route } from '@angular/router';
import { AppRoleGuard, RoleGuard } from '@univacity/angular/datas';
import { RoutePath } from '@univacity/shared/types';

import { APP_ROLE, USER_TYPE } from '@univacity/shared/types';
import { applicationRoutes } from './application/application.routes';
import { invoiceRoutes } from './invoice/invoice.routes';
import { messageRoutes } from './message/message.routes';
import { dashboardProgramsRoutes } from './program/dashboard-programs.routes';
import { quoteRoutes } from './quote/quote.routes';
import { settingsRoutes } from './settings/setting.routes';
import { dashboardToursRoutes } from './tour/dashboard-tour.routes';
import { visaApplicationRoutes } from './visa-application/visa-application.routes';
import { walletRoutes } from './wallet/wallet.routes';

export const dashboardRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [RoleGuard],
    loadComponent: () =>
      import(
        './dashboard-overview-page/dashboard-overview-page.component'
      ).then((m) => m.DashboardOverviewPageComponent),
  },
  {
    path: RoutePath.programs.replace('/', ''),
    children: dashboardProgramsRoutes,
  },
  {
    path: RoutePath.tours.replace('/', ''),
    children: dashboardToursRoutes,
  },
  {
    path: RoutePath.visaApplication.replace('/', ''),
    children: visaApplicationRoutes,
  },
  {
    path: RoutePath.applications,
    children: applicationRoutes,
  },
  {
    path: RoutePath.invoices.replace('/', ''),
    children: invoiceRoutes,
  },
  {
    path: RoutePath.payments.replace('/', ''),
    children: quoteRoutes,
  },
  {
    path: RoutePath.settings.replace('/', ''),
    children: settingsRoutes,
  },
  {
    path: `${RoutePath.organisation}/${RoutePath.create}`,
    data: {
      roles: [USER_TYPE.admin],
    },
    loadComponent: () =>
      import(
        './settings/organisation/organisation-form/organisation-form.component'
      ).then((c) => c.OrganisationFormComponent),
  },
  {
    path: `${RoutePath.organisation}/:id/${RoutePath.edit}`,
    loadComponent: () =>
      import(
        './settings/organisation/organisation-form/organisation-form.component'
      ).then((c) => c.OrganisationFormComponent),
  },
  {
    path: `${RoutePath.compliance}/:id/${RoutePath.edit}`,
    loadComponent: () =>
      import(
        './settings/compliance/compliance-form/compliance-form.component'
      ).then((c) => c.ComplianceFormComponent),
    canActivate: [RoleGuard],
    canActivateChild: [RoleGuard],
    data: {
      roles: [USER_TYPE.admin, USER_TYPE.organisation],
      appRole: [APP_ROLE.admin],
    },
  },
  {
    path: RoutePath.wallets.replace('/', ''),
    children: walletRoutes,
    canActivate: [AppRoleGuard, RoleGuard],
    canActivateChild: [AppRoleGuard, RoleGuard],
    data: {
      appRole: [APP_ROLE.admin, APP_ROLE.finance],
      roles: [USER_TYPE.admin, USER_TYPE.organisation],
    },
  },
  {
    path: RoutePath.messages.replace('/', ''),
    children: messageRoutes,
  },
];
